import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import {
  IEditManualGstPayout,
  IEditManualPayout,
} from "@shared/lib/types/briefCampains";
import { FINANCE_INFLUENCER_QUERY_KEY } from "../contsants";

export function useEditManualGstPayout(campaignInfluencerId: string) {
  const {
    mutate: editManualGstPayout,
    isLoading: isEditing,
    isSuccess: isEdited,
  } = useMutation<IEditManualGstPayout>({
    mutationFn: async (payout) => {
      return await CampaignService.editManualGstPayout(payout).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...FINANCE_INFLUENCER_QUERY_KEY(campaignInfluencerId)],
      });
      // TODO: Invalidate relevant queries here
    },
    options: {},
  });

  return {
    editManualGstPayout,
    isEditing,
    isEdited,
  };
}
